exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".entity-tag-editor-modal .preview {\n  background-color: var(--color-accent-g2);\n}\n.entity-tag-editor-modal .preview .marked,\n.entity-tag-editor-modal .preview [marked] {\n  padding-top: 5px;\n}\n.entity-tag-editor-modal label .marked p,\n.entity-tag-editor-modal label [marked] p {\n  margin-bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/entityTag/EntityTagEditor.less
// module id = 2431
// module chunks = 0